angular.module('tf.services')

    .factory('UserVerificationService', ['HttpService','$http','$q','Session','$state','$cookies','AuthAlertService',
        function (HttpService, $http, $q, Session, $state, $cookies, AuthAlertService) {
            var service = {};

            service.verify = function(token){
                var defer = $q.defer();
                $http.post("/verification/user/" + token).then(function(res){
                    $cookies.put('user_email',res.data.local.email);
                    if(res.data && res.data.local.reset_password){
                        //Session.setEmail(res.data.local.email);
                        $state.go('signup.email', {tfref: res.data.referer, analytics_params:{initiator:'verification email'}});
                    } else {
                        $state.go('login');
                    }
                    defer.resolve();
                });
                return defer.promise;
            };

            service.join = function(token){
                var defer = $q.defer();
                $http.post("/verification/join/" + token).then(function(res){
                    $cookies.put('user_email',res.data.local.email);
                    if(res.data && res.data.local.reset_password){
                        //Session.setEmail(res.data.local.email);
                        $state.go('signup.email', {tfref: res.data.referer, analytics_params:{initiator:'verification email'}});
                    } else {
                        $state.go('login');
                    }
                    defer.resolve();
                }, function(){
                    $state.go('login');
                });
                return defer.promise;
            };

            service.resolve = function(){
                var defer = $q.defer();
                $http.get("/verification/user/resolve").then(
                    function(res){
                        defer.resolve();
                    },
                    function(err){
                        if(Session.user){
                            $state.go('app.farmers');
                        }else {
                            $state.go('home');
                        }
                        defer.reject();
                    }
                );
                return defer.promise;
            };

            service.resolveReferer = function(referer){
                var defer = $q.defer();
                $http.get("/verification/referer?ref=" + referer).then(
                    function(res){
                        defer.resolve(res.data);
                    },
                    function(err){
                        if(Session.user){
                            $state.go('app.farmers');
                        }else {
                            $state.go('home');
                        }
                        defer.reject();
                    }
                );
                return defer.promise;
            };

            service.resolveAdmin = function(){
                var defer = $q.defer();
                HttpService.get("user/me/admin").then(
                    function(res){
                        defer.resolve();
                    },
                    function(err){
                        if(Session.user){
                            $state.go('app.farmers');
                        }else {
                            $state.go('home');
                        }
                        defer.reject();
                    }
                );
                return defer.promise;
            };

            return service;
        }])
;
